export const EVENT = {
  CHANGE_TAG_TASK_FILTER_CHAT: "CHANGE_TAG_TASK_FILTER_CHAT",
};
